export interface Stock {
  /** the stock symbol  */
  symbol: string
  /** the date of the measurement (taken weekly) */
  date: string
  /** the measured market capitalization (in billions, USD) */
  marketCap: number
}

/**
 * **Market capitalizations of major US technology companies**. Weekly measurements taken from 2021-09-16 to 2024-11-15.
 */
export const stocks: Stock[] = [
  {
    symbol: 'AAPL',
    date: '09/16/2021',
    marketCap: 2453.1187,
  },
  {
    symbol: 'AAPL',
    date: '09/23/2021',
    marketCap: 2420.804,
  },
  {
    symbol: 'AAPL',
    date: '09/30/2021',
    marketCap: 2319.4289,
  },
  {
    symbol: 'AAPL',
    date: '10/07/2021',
    marketCap: 2348.7701,
  },
  {
    symbol: 'AAPL',
    date: '10/14/2021',
    marketCap: 2356.4742,
  },
  {
    symbol: 'AAPL',
    date: '10/21/2021',
    marketCap: 2450.2349,
  },
  {
    symbol: 'AAPL',
    date: '10/28/2021',
    marketCap: 2500.8853,
  },
  {
    symbol: 'AAPL',
    date: '11/04/2021',
    marketCap: 2474.4947,
  },
  {
    symbol: 'AAPL',
    date: '11/11/2021',
    marketCap: 2423.8442,
  },
  {
    symbol: 'AAPL',
    date: '11/18/2021',
    marketCap: 2587.7615,
  },
  {
    symbol: 'AAPL',
    date: '11/24/2021',
    marketCap: 2654.4758,
  },
  {
    symbol: 'AAPL',
    date: '12/02/2021',
    marketCap: 2684.3087,
  },
  {
    symbol: 'AAPL',
    date: '12/09/2021',
    marketCap: 2861.3393,
  },
  {
    symbol: 'AAPL',
    date: '12/16/2021',
    marketCap: 2823.6384,
  },
  {
    symbol: 'AAPL',
    date: '12/23/2021',
    marketCap: 2889.5331,
  },
  {
    symbol: 'AAPL',
    date: '12/30/2021',
    marketCap: 2900.8825,
  },
  {
    symbol: 'AAPL',
    date: '12/31/2021',
    marketCap: 2890.6269,
  },
  {
    symbol: 'AAPL',
    date: '01/07/2022',
    marketCap: 2802.7213,
  },
  {
    symbol: 'AAPL',
    date: '01/14/2022',
    marketCap: 2817.3723,
  },
  {
    symbol: 'AAPL',
    date: '01/21/2022',
    marketCap: 2643.8402,
  },
  {
    symbol: 'AAPL',
    date: '01/28/2022',
    marketCap: 2772.7683,
  },
  {
    symbol: 'AAPL',
    date: '02/04/2022',
    marketCap: 2806.3027,
  },
  {
    symbol: 'AAPL',
    date: '02/11/2022',
    marketCap: 2745.2572,
  },
  {
    symbol: 'AAPL',
    date: '02/18/2022',
    marketCap: 2723.4436,
  },
  {
    symbol: 'AAPL',
    date: '02/25/2022',
    marketCap: 2683.5605,
  },
  {
    symbol: 'AAPL',
    date: '03/04/2022',
    marketCap: 2656.2121,
  },
  {
    symbol: 'AAPL',
    date: '03/11/2022',
    marketCap: 2518.819,
  },
  {
    symbol: 'AAPL',
    date: '03/18/2022',
    marketCap: 2669.398,
  },
  {
    symbol: 'AAPL',
    date: '03/25/2022',
    marketCap: 2844.2323,
  },
  {
    symbol: 'AAPL',
    date: '04/01/2022',
    marketCap: 2817.3629,
  },
  {
    symbol: 'AAPL',
    date: '04/08/2022',
    marketCap: 2749.1553,
  },
  {
    symbol: 'AAPL',
    date: '04/14/2022',
    marketCap: 2671.5732,
  },
  {
    symbol: 'AAPL',
    date: '04/22/2022',
    marketCap: 2615.0029,
  },
  {
    symbol: 'AAPL',
    date: '04/29/2022',
    marketCap: 2548.0883,
  },
  {
    symbol: 'AAPL',
    date: '05/06/2022',
    marketCap: 2542.108,
  },
  {
    symbol: 'AAPL',
    date: '05/13/2022',
    marketCap: 2377.7308,
  },
  {
    symbol: 'AAPL',
    date: '05/20/2022',
    marketCap: 2223.8596,
  },
  {
    symbol: 'AAPL',
    date: '05/27/2022',
    marketCap: 2418.6231,
  },
  {
    symbol: 'AAPL',
    date: '06/03/2022',
    marketCap: 2349.7689,
  },
  {
    symbol: 'AAPL',
    date: '06/10/2022',
    marketCap: 2216.4246,
  },
  {
    symbol: 'AAPL',
    date: '06/17/2022',
    marketCap: 2126.397,
  },
  {
    symbol: 'AAPL',
    date: '06/24/2022',
    marketCap: 2289.6428,
  },
  {
    symbol: 'AAPL',
    date: '07/01/2022',
    marketCap: 2227.101,
  },
  {
    symbol: 'AAPL',
    date: '07/08/2022',
    marketCap: 2357.1074,
  },
  {
    symbol: 'AAPL',
    date: '07/15/2022',
    marketCap: 2407.2825,
  },
  {
    symbol: 'AAPL',
    date: '07/22/2022',
    marketCap: 2470.1216,
  },
  {
    symbol: 'AAPL',
    date: '07/29/2022',
    marketCap: 2605.0974,
  },
  {
    symbol: 'AAPL',
    date: '08/05/2022',
    marketCap: 2650.6237,
  },
  {
    symbol: 'AAPL',
    date: '08/12/2022',
    marketCap: 2758.8287,
  },
  {
    symbol: 'AAPL',
    date: '08/19/2022',
    marketCap: 2749.5311,
  },
  {
    symbol: 'AAPL',
    date: '08/26/2022',
    marketCap: 2622.8911,
  },
  {
    symbol: 'AAPL',
    date: '09/02/2022',
    marketCap: 2497.6938,
  },
  {
    symbol: 'AAPL',
    date: '09/09/2022',
    marketCap: 2522.7012,
  },
  {
    symbol: 'AAPL',
    date: '09/16/2022',
    marketCap: 2415.7786,
  },
  {
    symbol: 'AAPL',
    date: '09/23/2022',
    marketCap: 2411.4504,
  },
  {
    symbol: 'AAPL',
    date: '09/30/2022',
    marketCap: 2196.3743,
  },
  {
    symbol: 'AAPL',
    date: '10/07/2022',
    marketCap: 2226.4116,
  },
  {
    symbol: 'AAPL',
    date: '10/14/2022',
    marketCap: 2199.235,
  },
  {
    symbol: 'AAPL',
    date: '10/21/2022',
    marketCap: 2340.5213,
  },
  {
    symbol: 'AAPL',
    date: '10/28/2022',
    marketCap: 2475.1327,
  },
  {
    symbol: 'AAPL',
    date: '11/04/2022',
    marketCap: 2199.235,
  },
  {
    symbol: 'AAPL',
    date: '11/11/2022',
    marketCap: 2379.1406,
  },
  {
    symbol: 'AAPL',
    date: '11/18/2022',
    marketCap: 2404.4101,
  },
  {
    symbol: 'AAPL',
    date: '11/25/2022',
    marketCap: 2353.8712,
  },
  {
    symbol: 'AAPL',
    date: '12/02/2022',
    marketCap: 2349.1034,
  },
  {
    symbol: 'AAPL',
    date: '12/09/2022',
    marketCap: 2259.3095,
  },
  {
    symbol: 'AAPL',
    date: '12/16/2022',
    marketCap: 2137.7302,
  },
  {
    symbol: 'AAPL',
    date: '12/23/2022',
    marketCap: 2095.6145,
  },
  {
    symbol: 'AAPL',
    date: '12/30/2022',
    marketCap: 2064.9415,
  },
  {
    symbol: 'AAPL',
    date: '01/06/2023',
    marketCap: 2046.3309,
  },
  {
    symbol: 'AAPL',
    date: '01/13/2023',
    marketCap: 2127.4769,
  },
  {
    symbol: 'AAPL',
    date: '01/20/2023',
    marketCap: 2176.5749,
  },
  {
    symbol: 'AAPL',
    date: '01/27/2023',
    marketCap: 2303.8194,
  },
  {
    symbol: 'AAPL',
    date: '02/03/2023',
    marketCap: 2439.1153,
  },
  {
    symbol: 'AAPL',
    date: '02/10/2023',
    marketCap: 2384.0181,
  },
  {
    symbol: 'AAPL',
    date: '02/17/2023',
    marketCap: 2408.3303,
  },
  {
    symbol: 'AAPL',
    date: '02/24/2023',
    marketCap: 2316.1334,
  },
  {
    symbol: 'AAPL',
    date: '03/03/2023',
    marketCap: 2384.3339,
  },
  {
    symbol: 'AAPL',
    date: '03/10/2023',
    marketCap: 2344.3924,
  },
  {
    symbol: 'AAPL',
    date: '03/17/2023',
    marketCap: 2447.0089,
  },
  {
    symbol: 'AAPL',
    date: '03/24/2023',
    marketCap: 2529.8914,
  },
  {
    symbol: 'AAPL',
    date: '03/31/2023',
    marketCap: 2603.3017,
  },
  {
    symbol: 'AAPL',
    date: '04/06/2023',
    marketCap: 2584.7691,
  },
  {
    symbol: 'AAPL',
    date: '04/14/2023',
    marketCap: 2593.4028,
  },
  {
    symbol: 'AAPL',
    date: '04/21/2023',
    marketCap: 2590.4203,
  },
  {
    symbol: 'AAPL',
    date: '04/28/2023',
    marketCap: 2663.5711,
  },
  {
    symbol: 'AAPL',
    date: '05/05/2023',
    marketCap: 2724.6349,
  },
  {
    symbol: 'AAPL',
    date: '05/12/2023',
    marketCap: 2708.9372,
  },
  {
    symbol: 'AAPL',
    date: '05/19/2023',
    marketCap: 2749.5941,
  },
  {
    symbol: 'AAPL',
    date: '05/26/2023',
    marketCap: 2753.8324,
  },
  {
    symbol: 'AAPL',
    date: '06/02/2023',
    marketCap: 2840.4833,
  },
  {
    symbol: 'AAPL',
    date: '06/09/2023',
    marketCap: 2840.6402,
  },
  {
    symbol: 'AAPL',
    date: '06/16/2023',
    marketCap: 2902.8028,
  },
  {
    symbol: 'AAPL',
    date: '06/23/2023',
    marketCap: 2930.4306,
  },
  {
    symbol: 'AAPL',
    date: '06/30/2023',
    marketCap: 3044.8662,
  },
  {
    symbol: 'AAPL',
    date: '07/07/2023',
    marketCap: 2974.5001,
  },
  {
    symbol: 'AAPL',
    date: '07/14/2023',
    marketCap: 2974.6561,
  },
  {
    symbol: 'AAPL',
    date: '07/21/2023',
    marketCap: 2994.1554,
  },
  {
    symbol: 'AAPL',
    date: '07/28/2023',
    marketCap: 3054.8372,
  },
  {
    symbol: 'AAPL',
    date: '08/04/2023',
    marketCap: 2838.941,
  },
  {
    symbol: 'AAPL',
    date: '08/11/2023',
    marketCap: 2773.4234,
  },
  {
    symbol: 'AAPL',
    date: '08/18/2023',
    marketCap: 2721.9452,
  },
  {
    symbol: 'AAPL',
    date: '08/25/2023',
    marketCap: 2786.2149,
  },
  {
    symbol: 'AAPL',
    date: '09/01/2023',
    marketCap: 2955.4688,
  },
  {
    symbol: 'AAPL',
    date: '09/08/2023',
    marketCap: 2779.5072,
  },
  {
    symbol: 'AAPL',
    date: '09/15/2023',
    marketCap: 2730.0569,
  },
  {
    symbol: 'AAPL',
    date: '09/22/2023',
    marketCap: 2726.6251,
  },
  {
    symbol: 'AAPL',
    date: '09/29/2023',
    marketCap: 2670.7791,
  },
  {
    symbol: 'AAPL',
    date: '10/06/2023',
    marketCap: 2752.8278,
  },
  {
    symbol: 'AAPL',
    date: '10/13/2023',
    marketCap: 2773.9211,
  },
  {
    symbol: 'AAPL',
    date: '10/20/2023',
    marketCap: 2681.3278,
  },
  {
    symbol: 'AAPL',
    date: '10/27/2023',
    marketCap: 2609.0523,
  },
  {
    symbol: 'AAPL',
    date: '11/03/2023',
    marketCap: 2739.7996,
  },
  {
    symbol: 'AAPL',
    date: '11/10/2023',
    marketCap: 2891.0198,
  },
  {
    symbol: 'AAPL',
    date: '11/17/2023',
    marketCap: 2942.0469,
  },
  {
    symbol: 'AAPL',
    date: '11/24/2023',
    marketCap: 2946.3897,
  },
  {
    symbol: 'AAPL',
    date: '12/01/2023',
    marketCap: 2966.0871,
  },
  {
    symbol: 'AAPL',
    date: '12/08/2023',
    marketCap: 3035.4157,
  },
  {
    symbol: 'AAPL',
    date: '12/15/2023',
    marketCap: 3064.2639,
  },
  {
    symbol: 'AAPL',
    date: '12/22/2023',
    marketCap: 3002.6901,
  },
  {
    symbol: 'AAPL',
    date: '12/29/2023',
    marketCap: 2986.0947,
  },
  {
    symbol: 'AAPL',
    date: '01/05/2024',
    marketCap: 2791.233,
  },
  {
    symbol: 'AAPL',
    date: '01/12/2024',
    marketCap: 2864.2567,
  },
  {
    symbol: 'AAPL',
    date: '01/19/2024',
    marketCap: 2951.1458,
  },
  {
    symbol: 'AAPL',
    date: '01/26/2024',
    marketCap: 2964.3948,
  },
  {
    symbol: 'AAPL',
    date: '02/02/2024',
    marketCap: 2863.1783,
  },
  {
    symbol: 'AAPL',
    date: '02/09/2024',
    marketCap: 2909.3959,
  },
  {
    symbol: 'AAPL',
    date: '02/16/2024',
    marketCap: 2808.6416,
  },
  {
    symbol: 'AAPL',
    date: '02/23/2024',
    marketCap: 2811.8768,
  },
  {
    symbol: 'AAPL',
    date: '03/01/2024',
    marketCap: 2767.8161,
  },
  {
    symbol: 'AAPL',
    date: '03/08/2024',
    marketCap: 2630.2418,
  },
  {
    symbol: 'AAPL',
    date: '03/15/2024',
    marketCap: 2659.3589,
  },
  {
    symbol: 'AAPL',
    date: '03/22/2024',
    marketCap: 2654.1209,
  },
  {
    symbol: 'AAPL',
    date: '03/28/2024',
    marketCap: 2641.7962,
  },
  {
    symbol: 'AAPL',
    date: '04/05/2024',
    marketCap: 2597.9656,
  },
  {
    symbol: 'AAPL',
    date: '04/12/2024',
    marketCap: 2704.746,
  },
  {
    symbol: 'AAPL',
    date: '04/19/2024',
    marketCap: 2527.8,
  },
  {
    symbol: 'AAPL',
    date: '04/26/2024',
    marketCap: 2593.676,
  },
  {
    symbol: 'AAPL',
    date: '05/03/2024',
    marketCap: 2809.3816,
  },
  {
    symbol: 'AAPL',
    date: '05/10/2024',
    marketCap: 2804.326,
  },
  {
    symbol: 'AAPL',
    date: '05/17/2024',
    marketCap: 2908.8084,
  },
  {
    symbol: 'AAPL',
    date: '05/24/2024',
    marketCap: 2910.4936,
  },
  {
    symbol: 'AAPL',
    date: '05/31/2024',
    marketCap: 2945.27,
  },
  {
    symbol: 'AAPL',
    date: '06/07/2024',
    marketCap: 3016.3548,
  },
  {
    symbol: 'AAPL',
    date: '06/14/2024',
    marketCap: 3255.3468,
  },
  {
    symbol: 'AAPL',
    date: '06/21/2024',
    marketCap: 3178.7468,
  },
  {
    symbol: 'AAPL',
    date: '06/28/2024',
    marketCap: 3226.6984,
  },
  {
    symbol: 'AAPL',
    date: '07/05/2024',
    marketCap: 3434.0282,
  },
  {
    symbol: 'AAPL',
    date: '07/12/2024',
    marketCap: 3497.7506,
  },
  {
    symbol: 'AAPL',
    date: '07/19/2024',
    marketCap: 3403.2291,
  },
  {
    symbol: 'AAPL',
    date: '07/26/2024',
    marketCap: 3306.8869,
  },
  {
    symbol: 'AAPL',
    date: '08/02/2024',
    marketCap: 3335.7137,
  },
  {
    symbol: 'AAPL',
    date: '08/09/2024',
    marketCap: 3280.7911,
  },
  {
    symbol: 'AAPL',
    date: '08/16/2024',
    marketCap: 3429.6283,
  },
  {
    symbol: 'AAPL',
    date: '08/23/2024',
    marketCap: 3441.6142,
  },
  {
    symbol: 'AAPL',
    date: '08/30/2024',
    marketCap: 3474.3857,
  },
  {
    symbol: 'AAPL',
    date: '09/06/2024',
    marketCap: 3350.2788,
  },
  {
    symbol: 'AAPL',
    date: '09/13/2024',
    marketCap: 3375.7678,
  },
  {
    symbol: 'AAPL',
    date: '09/20/2024',
    marketCap: 3462.2481,
  },
  {
    symbol: 'AAPL',
    date: '09/27/2024',
    marketCap: 3456.0276,
  },
  {
    symbol: 'AAPL',
    date: '10/04/2024',
    marketCap: 3441.0073,
  },
  {
    symbol: 'AAPL',
    date: '10/11/2024',
    marketCap: 3452.3863,
  },
  {
    symbol: 'AAPL',
    date: '10/18/2024',
    marketCap: 3565.4176,
  },
  {
    symbol: 'AAPL',
    date: '10/25/2024',
    marketCap: 3510.9502,
  },
  {
    symbol: 'AAPL',
    date: '11/01/2024',
    marketCap: 3381.9883,
  },
  {
    symbol: 'AAPL',
    date: '11/08/2024',
    marketCap: 3443.4349,
  },
  {
    symbol: 'AAPL',
    date: '11/15/2024',
    marketCap: 3413.6977,
  },
  {
    symbol: 'AMZN',
    date: '09/16/2021',
    marketCap: 1768.5174,
  },
  {
    symbol: 'AMZN',
    date: '09/23/2021',
    marketCap: 1731.912,
  },
  {
    symbol: 'AMZN',
    date: '09/30/2021',
    marketCap: 1668.78,
  },
  {
    symbol: 'AMZN',
    date: '10/07/2021',
    marketCap: 1677.6192,
  },
  {
    symbol: 'AMZN',
    date: '10/14/2021',
    marketCap: 1676.2984,
  },
  {
    symbol: 'AMZN',
    date: '10/21/2021',
    marketCap: 1744.98,
  },
  {
    symbol: 'AMZN',
    date: '10/28/2021',
    marketCap: 1750.8728,
  },
  {
    symbol: 'AMZN',
    date: '11/04/2021',
    marketCap: 1766.316,
  },
  {
    symbol: 'AMZN',
    date: '11/11/2021',
    marketCap: 1764.0808,
  },
  {
    symbol: 'AMZN',
    date: '11/18/2021',
    marketCap: 1877.568,
  },
  {
    symbol: 'AMZN',
    date: '11/24/2021',
    marketCap: 1818.8432,
  },
  {
    symbol: 'AMZN',
    date: '12/02/2021',
    marketCap: 1746.1992,
  },
  {
    symbol: 'AMZN',
    date: '12/09/2021',
    marketCap: 1769.5672,
  },
  {
    symbol: 'AMZN',
    date: '12/16/2021',
    marketCap: 1715.7192,
  },
  {
    symbol: 'AMZN',
    date: '12/23/2021',
    marketCap: 1738.0712,
  },
  {
    symbol: 'AMZN',
    date: '12/30/2021',
    marketCap: 1713.3824,
  },
  {
    symbol: 'AMZN',
    date: '12/31/2021',
    marketCap: 1697.2096,
  },
  {
    symbol: 'AMZN',
    date: '01/07/2022',
    marketCap: 1654.759,
  },
  {
    symbol: 'AMZN',
    date: '01/14/2022',
    marketCap: 1650.5852,
  },
  {
    symbol: 'AMZN',
    date: '01/21/2022',
    marketCap: 1452.0752,
  },
  {
    symbol: 'AMZN',
    date: '01/28/2022',
    marketCap: 1465.7164,
  },
  {
    symbol: 'AMZN',
    date: '02/04/2022',
    marketCap: 1604.7752,
  },
  {
    symbol: 'AMZN',
    date: '02/11/2022',
    marketCap: 1560.4922,
  },
  {
    symbol: 'AMZN',
    date: '02/18/2022',
    marketCap: 1553.468,
  },
  {
    symbol: 'AMZN',
    date: '02/25/2022',
    marketCap: 1565.5822,
  },
  {
    symbol: 'AMZN',
    date: '03/04/2022',
    marketCap: 1482.6152,
  },
  {
    symbol: 'AMZN',
    date: '03/11/2022',
    marketCap: 1481.3936,
  },
  {
    symbol: 'AMZN',
    date: '03/18/2022',
    marketCap: 1641.525,
  },
  {
    symbol: 'AMZN',
    date: '03/25/2022',
    marketCap: 1677.3586,
  },
  {
    symbol: 'AMZN',
    date: '04/01/2022',
    marketCap: 1664.223,
  },
  {
    symbol: 'AMZN',
    date: '04/08/2022',
    marketCap: 1571.6305,
  },
  {
    symbol: 'AMZN',
    date: '04/14/2022',
    marketCap: 1543.6492,
  },
  {
    symbol: 'AMZN',
    date: '04/22/2022',
    marketCap: 1468.7613,
  },
  {
    symbol: 'AMZN',
    date: '04/29/2022',
    marketCap: 1264.549,
  },
  {
    symbol: 'AMZN',
    date: '05/06/2022',
    marketCap: 1167.7848,
  },
  {
    symbol: 'AMZN',
    date: '05/13/2022',
    marketCap: 1150.3855,
  },
  {
    symbol: 'AMZN',
    date: '05/20/2022',
    marketCap: 1094.7282,
  },
  {
    symbol: 'AMZN',
    date: '05/27/2022',
    marketCap: 1171.6512,
  },
  {
    symbol: 'AMZN',
    date: '06/03/2022',
    marketCap: 1244.9113,
  },
  {
    symbol: 'AMZN',
    date: '06/10/2022',
    marketCap: 1115.6888,
  },
  {
    symbol: 'AMZN',
    date: '06/17/2022',
    marketCap: 1080.7885,
  },
  {
    symbol: 'AMZN',
    date: '06/24/2022',
    marketCap: 1184.9805,
  },
  {
    symbol: 'AMZN',
    date: '07/01/2022',
    marketCap: 1116.526,
  },
  {
    symbol: 'AMZN',
    date: '07/08/2022',
    marketCap: 1177.4681,
  },
  {
    symbol: 'AMZN',
    date: '07/15/2022',
    marketCap: 1157.188,
  },
  {
    symbol: 'AMZN',
    date: '07/22/2022',
    marketCap: 1247.5822,
  },
  {
    symbol: 'AMZN',
    date: '07/29/2022',
    marketCap: 1375.2755,
  },
  {
    symbol: 'AMZN',
    date: '08/05/2022',
    marketCap: 1434.8928,
  },
  {
    symbol: 'AMZN',
    date: '08/12/2022',
    marketCap: 1462.918,
  },
  {
    symbol: 'AMZN',
    date: '08/19/2022',
    marketCap: 1408.7019,
  },
  {
    symbol: 'AMZN',
    date: '08/26/2022',
    marketCap: 1332.4733,
  },
  {
    symbol: 'AMZN',
    date: '09/02/2022',
    marketCap: 1299.4544,
  },
  {
    symbol: 'AMZN',
    date: '09/09/2022',
    marketCap: 1358.1546,
  },
  {
    symbol: 'AMZN',
    date: '09/16/2022',
    marketCap: 1258.8942,
  },
  {
    symbol: 'AMZN',
    date: '09/23/2022',
    marketCap: 1159.532,
  },
  {
    symbol: 'AMZN',
    date: '09/30/2022',
    marketCap: 1154.86,
  },
  {
    symbol: 'AMZN',
    date: '10/07/2022',
    marketCap: 1170.8032,
  },
  {
    symbol: 'AMZN',
    date: '10/14/2022',
    marketCap: 1092.518,
  },
  {
    symbol: 'AMZN',
    date: '10/21/2022',
    marketCap: 1219.4504,
  },
  {
    symbol: 'AMZN',
    date: '10/28/2022',
    marketCap: 1056.8502,
  },
  {
    symbol: 'AMZN',
    date: '11/04/2022',
    marketCap: 929.8156,
  },
  {
    symbol: 'AMZN',
    date: '11/11/2022',
    marketCap: 1030.0738,
  },
  {
    symbol: 'AMZN',
    date: '11/18/2022',
    marketCap: 962.1108,
  },
  {
    symbol: 'AMZN',
    date: '11/25/2022',
    marketCap: 954.6502,
  },
  {
    symbol: 'AMZN',
    date: '12/02/2022',
    marketCap: 962.0086,
  },
  {
    symbol: 'AMZN',
    date: '12/09/2022',
    marketCap: 910.4998,
  },
  {
    symbol: 'AMZN',
    date: '12/16/2022',
    marketCap: 897.9292,
  },
  {
    symbol: 'AMZN',
    date: '12/23/2022',
    marketCap: 871.255,
  },
  {
    symbol: 'AMZN',
    date: '12/30/2022',
    marketCap: 858.48,
  },
  {
    symbol: 'AMZN',
    date: '01/06/2023',
    marketCap: 882.32,
  },
  {
    symbol: 'AMZN',
    date: '01/13/2023',
    marketCap: 1005.73,
  },
  {
    symbol: 'AMZN',
    date: '01/20/2023',
    marketCap: 996.8125,
  },
  {
    symbol: 'AMZN',
    date: '01/27/2023',
    marketCap: 1047.96,
  },
  {
    symbol: 'AMZN',
    date: '02/03/2023',
    marketCap: 1059.7475,
  },
  {
    symbol: 'AMZN',
    date: '02/10/2023',
    marketCap: 1000.5025,
  },
  {
    symbol: 'AMZN',
    date: '02/17/2023',
    marketCap: 996.3,
  },
  {
    symbol: 'AMZN',
    date: '02/24/2023',
    marketCap: 958.375,
  },
  {
    symbol: 'AMZN',
    date: '03/03/2023',
    marketCap: 972.725,
  },
  {
    symbol: 'AMZN',
    date: '03/10/2023',
    marketCap: 929.9825,
  },
  {
    symbol: 'AMZN',
    date: '03/17/2023',
    marketCap: 1014.2375,
  },
  {
    symbol: 'AMZN',
    date: '03/24/2023',
    marketCap: 1005.8325,
  },
  {
    symbol: 'AMZN',
    date: '03/31/2023',
    marketCap: 1062.3376,
  },
  {
    symbol: 'AMZN',
    date: '04/06/2023',
    marketCap: 1049.6871,
  },
  {
    symbol: 'AMZN',
    date: '04/14/2023',
    marketCap: 1054.3154,
  },
  {
    symbol: 'AMZN',
    date: '04/21/2023',
    marketCap: 1100.0836,
  },
  {
    symbol: 'AMZN',
    date: '04/28/2023',
    marketCap: 1084.5532,
  },
  {
    symbol: 'AMZN',
    date: '05/05/2023',
    marketCap: 1086.7131,
  },
  {
    symbol: 'AMZN',
    date: '05/12/2023',
    marketCap: 1134.0241,
  },
  {
    symbol: 'AMZN',
    date: '05/19/2023',
    marketCap: 1195.6312,
  },
  {
    symbol: 'AMZN',
    date: '05/26/2023',
    marketCap: 1235.3313,
  },
  {
    symbol: 'AMZN',
    date: '06/02/2023',
    marketCap: 1277.9113,
  },
  {
    symbol: 'AMZN',
    date: '06/09/2023',
    marketCap: 1269.4776,
  },
  {
    symbol: 'AMZN',
    date: '06/16/2023',
    marketCap: 1290.6646,
  },
  {
    symbol: 'AMZN',
    date: '06/23/2023',
    marketCap: 1330.159,
  },
  {
    symbol: 'AMZN',
    date: '06/30/2023',
    marketCap: 1345.5759,
  },
  {
    symbol: 'AMZN',
    date: '07/07/2023',
    marketCap: 1339.5892,
  },
  {
    symbol: 'AMZN',
    date: '07/14/2023',
    marketCap: 1390.167,
  },
  {
    symbol: 'AMZN',
    date: '07/21/2023',
    marketCap: 1341.86,
  },
  {
    symbol: 'AMZN',
    date: '07/28/2023',
    marketCap: 1364.6716,
  },
  {
    symbol: 'AMZN',
    date: '08/04/2023',
    marketCap: 1440.6415,
  },
  {
    symbol: 'AMZN',
    date: '08/11/2023',
    marketCap: 1428.668,
  },
  {
    symbol: 'AMZN',
    date: '08/18/2023',
    marketCap: 1375.0968,
  },
  {
    symbol: 'AMZN',
    date: '08/25/2023',
    marketCap: 1375.5097,
  },
  {
    symbol: 'AMZN',
    date: '09/01/2023',
    marketCap: 1425.6746,
  },
  {
    symbol: 'AMZN',
    date: '09/08/2023',
    marketCap: 1426.8101,
  },
  {
    symbol: 'AMZN',
    date: '09/15/2023',
    marketCap: 1449.1056,
  },
  {
    symbol: 'AMZN',
    date: '09/22/2023',
    marketCap: 1332.7766,
  },
  {
    symbol: 'AMZN',
    date: '09/29/2023',
    marketCap: 1312.1326,
  },
  {
    symbol: 'AMZN',
    date: '10/06/2023',
    marketCap: 1325.1538,
  },
  {
    symbol: 'AMZN',
    date: '10/13/2023',
    marketCap: 1344.1052,
  },
  {
    symbol: 'AMZN',
    date: '10/20/2023',
    marketCap: 1296.2605,
  },
  {
    symbol: 'AMZN',
    date: '10/27/2023',
    marketCap: 1322.8754,
  },
  {
    symbol: 'AMZN',
    date: '11/03/2023',
    marketCap: 1435.3416,
  },
  {
    symbol: 'AMZN',
    date: '11/10/2023',
    marketCap: 1486.7074,
  },
  {
    symbol: 'AMZN',
    date: '11/17/2023',
    marketCap: 1503.4841,
  },
  {
    symbol: 'AMZN',
    date: '11/24/2023',
    marketCap: 1519.6394,
  },
  {
    symbol: 'AMZN',
    date: '12/01/2023',
    marketCap: 1522.6427,
  },
  {
    symbol: 'AMZN',
    date: '12/08/2023',
    marketCap: 1526.6815,
  },
  {
    symbol: 'AMZN',
    date: '12/15/2023',
    marketCap: 1553.0893,
  },
  {
    symbol: 'AMZN',
    date: '12/22/2023',
    marketCap: 1588.8175,
  },
  {
    symbol: 'AMZN',
    date: '12/29/2023',
    marketCap: 1573.4906,
  },
  {
    symbol: 'AMZN',
    date: '01/05/2024',
    marketCap: 1509.4793,
  },
  {
    symbol: 'AMZN',
    date: '01/12/2024',
    marketCap: 1606.9657,
  },
  {
    symbol: 'AMZN',
    date: '01/19/2024',
    marketCap: 1614.4486,
  },
  {
    symbol: 'AMZN',
    date: '01/26/2024',
    marketCap: 1653.7342,
  },
  {
    symbol: 'AMZN',
    date: '02/02/2024',
    marketCap: 1785.6213,
  },
  {
    symbol: 'AMZN',
    date: '02/09/2024',
    marketCap: 1813.0588,
  },
  {
    symbol: 'AMZN',
    date: '02/16/2024',
    marketCap: 1761.7174,
  },
  {
    symbol: 'AMZN',
    date: '02/23/2024',
    marketCap: 1818.6711,
  },
  {
    symbol: 'AMZN',
    date: '03/01/2024',
    marketCap: 1852.2405,
  },
  {
    symbol: 'AMZN',
    date: '03/08/2024',
    marketCap: 1822.4126,
  },
  {
    symbol: 'AMZN',
    date: '03/15/2024',
    marketCap: 1812.7471,
  },
  {
    symbol: 'AMZN',
    date: '03/22/2024',
    marketCap: 1858.9959,
  },
  {
    symbol: 'AMZN',
    date: '03/28/2024',
    marketCap: 1874.6893,
  },
  {
    symbol: 'AMZN',
    date: '04/05/2024',
    marketCap: 1933.4263,
  },
  {
    symbol: 'AMZN',
    date: '04/12/2024',
    marketCap: 1944.5001,
  },
  {
    symbol: 'AMZN',
    date: '04/19/2024',
    marketCap: 1824.3596,
  },
  {
    symbol: 'AMZN',
    date: '04/26/2024',
    marketCap: 1876.4901,
  },
  {
    symbol: 'AMZN',
    date: '05/03/2024',
    marketCap: 1945.3359,
  },
  {
    symbol: 'AMZN',
    date: '05/10/2024',
    marketCap: 1958.6036,
  },
  {
    symbol: 'AMZN',
    date: '05/17/2024',
    marketCap: 1929.5609,
  },
  {
    symbol: 'AMZN',
    date: '05/24/2024',
    marketCap: 1888.2952,
  },
  {
    symbol: 'AMZN',
    date: '05/31/2024',
    marketCap: 1843.2687,
  },
  {
    symbol: 'AMZN',
    date: '06/07/2024',
    marketCap: 1925.3821,
  },
  {
    symbol: 'AMZN',
    date: '06/14/2024',
    marketCap: 1918.696,
  },
  {
    symbol: 'AMZN',
    date: '06/21/2024',
    marketCap: 1975.3188,
  },
  {
    symbol: 'AMZN',
    date: '06/28/2024',
    marketCap: 2018.8827,
  },
  {
    symbol: 'AMZN',
    date: '07/05/2024',
    marketCap: 2100.2,
  },
  {
    symbol: 'AMZN',
    date: '07/12/2024',
    marketCap: 2042.3395,
  },
  {
    symbol: 'AMZN',
    date: '07/19/2024',
    marketCap: 1923.0481,
  },
  {
    symbol: 'AMZN',
    date: '07/26/2024',
    marketCap: 1916.4325,
  },
  {
    symbol: 'AMZN',
    date: '08/02/2024',
    marketCap: 1763.1179,
  },
  {
    symbol: 'AMZN',
    date: '08/09/2024',
    marketCap: 1753.0369,
  },
  {
    symbol: 'AMZN',
    date: '08/16/2024',
    marketCap: 1859.3071,
  },
  {
    symbol: 'AMZN',
    date: '08/23/2024',
    marketCap: 1859.097,
  },
  {
    symbol: 'AMZN',
    date: '08/30/2024',
    marketCap: 1874.4285,
  },
  {
    symbol: 'AMZN',
    date: '09/06/2024',
    marketCap: 1799.7664,
  },
  {
    symbol: 'AMZN',
    date: '09/13/2024',
    marketCap: 1958.3315,
  },
  {
    symbol: 'AMZN',
    date: '09/20/2024',
    marketCap: 2011.9916,
  },
  {
    symbol: 'AMZN',
    date: '09/27/2024',
    marketCap: 1973.873,
  },
  {
    symbol: 'AMZN',
    date: '10/04/2024',
    marketCap: 1958.5415,
  },
  {
    symbol: 'AMZN',
    date: '10/11/2024',
    marketCap: 1982.7988,
  },
  {
    symbol: 'AMZN',
    date: '10/18/2024',
    marketCap: 1984.584,
  },
  {
    symbol: 'AMZN',
    date: '10/25/2024',
    marketCap: 1972.4028,
  },
  {
    symbol: 'AMZN',
    date: '11/01/2024',
    marketCap: 2078.4629,
  },
  {
    symbol: 'AMZN',
    date: '11/08/2024',
    marketCap: 2186.0982,
  },
  {
    symbol: 'AMZN',
    date: '11/15/2024',
    marketCap: 2127.6076,
  },
  {
    symbol: 'GOOG',
    date: '09/16/2021',
    marketCap: 1912.1893,
  },
  {
    symbol: 'GOOG',
    date: '09/23/2021',
    marketCap: 1880.366,
  },
  {
    symbol: 'GOOG',
    date: '09/30/2021',
    marketCap: 1771.695,
  },
  {
    symbol: 'GOOG',
    date: '10/07/2021',
    marketCap: 1845.2506,
  },
  {
    symbol: 'GOOG',
    date: '10/14/2021',
    marketCap: 1870.6968,
  },
  {
    symbol: 'GOOG',
    date: '10/21/2021',
    marketCap: 1880.5042,
  },
  {
    symbol: 'GOOG',
    date: '10/28/2021',
    marketCap: 1932.9871,
  },
  {
    symbol: 'GOOG',
    date: '11/04/2021',
    marketCap: 1965.06,
  },
  {
    symbol: 'GOOG',
    date: '11/11/2021',
    marketCap: 1931.9268,
  },
  {
    symbol: 'GOOG',
    date: '11/18/2021',
    marketCap: 1985.8676,
  },
  {
    symbol: 'GOOG',
    date: '11/24/2021',
    marketCap: 1936.5655,
  },
  {
    symbol: 'GOOG',
    date: '12/02/2021',
    marketCap: 1894.8177,
  },
  {
    symbol: 'GOOG',
    date: '12/09/2021',
    marketCap: 1956.7104,
  },
  {
    symbol: 'GOOG',
    date: '12/16/2021',
    marketCap: 1914.4325,
  },
  {
    symbol: 'GOOG',
    date: '12/23/2021',
    marketCap: 1947.1681,
  },
  {
    symbol: 'GOOG',
    date: '12/30/2021',
    marketCap: 1937.6257,
  },
  {
    symbol: 'GOOG',
    date: '12/31/2021',
    marketCap: 1912.4545,
  },
  {
    symbol: 'GOOG',
    date: '01/07/2022',
    marketCap: 1809.0751,
  },
  {
    symbol: 'GOOG',
    date: '01/14/2022',
    marketCap: 1841.5544,
  },
  {
    symbol: 'GOOG',
    date: '01/21/2022',
    marketCap: 1721.0111,
  },
  {
    symbol: 'GOOG',
    date: '01/28/2022',
    marketCap: 1760.62,
  },
  {
    symbol: 'GOOG',
    date: '02/04/2022',
    marketCap: 1891.8579,
  },
  {
    symbol: 'GOOG',
    date: '02/11/2022',
    marketCap: 1772.8988,
  },
  {
    symbol: 'GOOG',
    date: '02/18/2022',
    marketCap: 1721.6712,
  },
  {
    symbol: 'GOOG',
    date: '02/25/2022',
    marketCap: 1775.2754,
  },
  {
    symbol: 'GOOG',
    date: '03/04/2022',
    marketCap: 1741.6077,
  },
  {
    symbol: 'GOOG',
    date: '03/11/2022',
    marketCap: 1714.6736,
  },
  {
    symbol: 'GOOG',
    date: '03/18/2022',
    marketCap: 1797.3244,
  },
  {
    symbol: 'GOOG',
    date: '03/25/2022',
    marketCap: 1870.469,
  },
  {
    symbol: 'GOOG',
    date: '04/01/2022',
    marketCap: 1845.4952,
  },
  {
    symbol: 'GOOG',
    date: '04/08/2022',
    marketCap: 1755.1627,
  },
  {
    symbol: 'GOOG',
    date: '04/14/2022',
    marketCap: 1668.7806,
  },
  {
    symbol: 'GOOG',
    date: '04/22/2022',
    marketCap: 1575.4195,
  },
  {
    symbol: 'GOOG',
    date: '04/29/2022',
    marketCap: 1502.6005,
  },
  {
    symbol: 'GOOG',
    date: '05/06/2022',
    marketCap: 1524.196,
  },
  {
    symbol: 'GOOG',
    date: '05/13/2022',
    marketCap: 1528.1464,
  },
  {
    symbol: 'GOOG',
    date: '05/20/2022',
    marketCap: 1434.1269,
  },
  {
    symbol: 'GOOG',
    date: '05/27/2022',
    marketCap: 1479.0298,
  },
  {
    symbol: 'GOOG',
    date: '06/03/2022',
    marketCap: 1508.2627,
  },
  {
    symbol: 'GOOG',
    date: '06/10/2022',
    marketCap: 1463.7549,
  },
  {
    symbol: 'GOOG',
    date: '06/17/2022',
    marketCap: 1410.8195,
  },
  {
    symbol: 'GOOG',
    date: '06/24/2022',
    marketCap: 1553.5606,
  },
  {
    symbol: 'GOOG',
    date: '07/01/2022',
    marketCap: 1413.62,
  },
  {
    symbol: 'GOOG',
    date: '07/08/2022',
    marketCap: 1551.55,
  },
  {
    symbol: 'GOOG',
    date: '07/15/2022',
    marketCap: 1453.14,
  },
  {
    symbol: 'GOOG',
    date: '07/22/2022',
    marketCap: 1402.7,
  },
  {
    symbol: 'GOOG',
    date: '07/29/2022',
    marketCap: 1512.16,
  },
  {
    symbol: 'GOOG',
    date: '08/05/2022',
    marketCap: 1527.11,
  },
  {
    symbol: 'GOOG',
    date: '08/12/2022',
    marketCap: 1581.84,
  },
  {
    symbol: 'GOOG',
    date: '08/19/2022',
    marketCap: 1523.73,
  },
  {
    symbol: 'GOOG',
    date: '08/26/2022',
    marketCap: 1434.42,
  },
  {
    symbol: 'GOOG',
    date: '09/02/2022',
    marketCap: 1402.05,
  },
  {
    symbol: 'GOOG',
    date: '09/09/2022',
    marketCap: 1438.45,
  },
  {
    symbol: 'GOOG',
    date: '09/16/2022',
    marketCap: 1336.4,
  },
  {
    symbol: 'GOOG',
    date: '09/23/2022',
    marketCap: 1283.62,
  },
  {
    symbol: 'GOOG',
    date: '09/30/2022',
    marketCap: 1233.5981,
  },
  {
    symbol: 'GOOG',
    date: '10/07/2022',
    marketCap: 1272.676,
  },
  {
    symbol: 'GOOG',
    date: '10/14/2022',
    marketCap: 1245.3343,
  },
  {
    symbol: 'GOOG',
    date: '10/21/2022',
    marketCap: 1304.2736,
  },
  {
    symbol: 'GOOG',
    date: '10/28/2022',
    marketCap: 1241.8521,
  },
  {
    symbol: 'GOOG',
    date: '11/04/2022',
    marketCap: 1116.6223,
  },
  {
    symbol: 'GOOG',
    date: '11/11/2022',
    marketCap: 1243.3998,
  },
  {
    symbol: 'GOOG',
    date: '11/18/2022',
    marketCap: 1256.5547,
  },
  {
    symbol: 'GOOG',
    date: '11/25/2022',
    marketCap: 1256.9416,
  },
  {
    symbol: 'GOOG',
    date: '12/02/2022',
    marketCap: 1295.3747,
  },
  {
    symbol: 'GOOG',
    date: '12/09/2022',
    marketCap: 1197.2285,
  },
  {
    symbol: 'GOOG',
    date: '12/16/2022',
    marketCap: 1164.0832,
  },
  {
    symbol: 'GOOG',
    date: '12/23/2022',
    marketCap: 1150.7993,
  },
  {
    symbol: 'GOOG',
    date: '12/30/2022',
    marketCap: 1137.9023,
  },
  {
    symbol: 'GOOG',
    date: '01/06/2023',
    marketCap: 1116.2925,
  },
  {
    symbol: 'GOOG',
    date: '01/13/2023',
    marketCap: 1177.3857,
  },
  {
    symbol: 'GOOG',
    date: '01/20/2023',
    marketCap: 1252.7936,
  },
  {
    symbol: 'GOOG',
    date: '01/27/2023',
    marketCap: 1270.048,
  },
  {
    symbol: 'GOOG',
    date: '02/03/2023',
    marketCap: 1339.1932,
  },
  {
    symbol: 'GOOG',
    date: '02/10/2023',
    marketCap: 1208.6992,
  },
  {
    symbol: 'GOOG',
    date: '02/17/2023',
    marketCap: 1205.8873,
  },
  {
    symbol: 'GOOG',
    date: '02/24/2023',
    marketCap: 1139.1705,
  },
  {
    symbol: 'GOOG',
    date: '03/03/2023',
    marketCap: 1196.9407,
  },
  {
    symbol: 'GOOG',
    date: '03/10/2023',
    marketCap: 1158.342,
  },
  {
    symbol: 'GOOG',
    date: '03/17/2023',
    marketCap: 1298.8052,
  },
  {
    symbol: 'GOOG',
    date: '03/24/2023',
    marketCap: 1347.6286,
  },
  {
    symbol: 'GOOG',
    date: '03/31/2023',
    marketCap: 1314.0516,
  },
  {
    symbol: 'GOOG',
    date: '04/06/2023',
    marketCap: 1373.4646,
  },
  {
    symbol: 'GOOG',
    date: '04/14/2023',
    marketCap: 1379.1652,
  },
  {
    symbol: 'GOOG',
    date: '04/21/2023',
    marketCap: 1335.3339,
  },
  {
    symbol: 'GOOG',
    date: '04/28/2023',
    marketCap: 1359.7831,
  },
  {
    symbol: 'GOOG',
    date: '05/05/2023',
    marketCap: 1337.3608,
  },
  {
    symbol: 'GOOG',
    date: '05/12/2023',
    marketCap: 1488.6167,
  },
  {
    symbol: 'GOOG',
    date: '05/19/2023',
    marketCap: 1555.1237,
  },
  {
    symbol: 'GOOG',
    date: '05/26/2023',
    marketCap: 1578.5595,
  },
  {
    symbol: 'GOOG',
    date: '06/02/2023',
    marketCap: 1579.3196,
  },
  {
    symbol: 'GOOG',
    date: '06/09/2023',
    marketCap: 1548.4096,
  },
  {
    symbol: 'GOOG',
    date: '06/16/2023',
    marketCap: 1564.878,
  },
  {
    symbol: 'GOOG',
    date: '06/23/2023',
    marketCap: 1549.8031,
  },
  {
    symbol: 'GOOG',
    date: '06/30/2023',
    marketCap: 1505.9457,
  },
  {
    symbol: 'GOOG',
    date: '07/07/2023',
    marketCap: 1503.1779,
  },
  {
    symbol: 'GOOG',
    date: '07/14/2023',
    marketCap: 1577.909,
  },
  {
    symbol: 'GOOG',
    date: '07/21/2023',
    marketCap: 1509.9716,
  },
  {
    symbol: 'GOOG',
    date: '07/28/2023',
    marketCap: 1667.989,
  },
  {
    symbol: 'GOOG',
    date: '08/04/2023',
    marketCap: 1611.7519,
  },
  {
    symbol: 'GOOG',
    date: '08/11/2023',
    marketCap: 1629.9944,
  },
  {
    symbol: 'GOOG',
    date: '08/18/2023',
    marketCap: 1603.5743,
  },
  {
    symbol: 'GOOG',
    date: '08/25/2023',
    marketCap: 1634.0203,
  },
  {
    symbol: 'GOOG',
    date: '09/01/2023',
    marketCap: 1706.7385,
  },
  {
    symbol: 'GOOG',
    date: '09/08/2023',
    marketCap: 1715.7968,
  },
  {
    symbol: 'GOOG',
    date: '09/15/2023',
    marketCap: 1728.6294,
  },
  {
    symbol: 'GOOG',
    date: '09/22/2023',
    marketCap: 1638.6753,
  },
  {
    symbol: 'GOOG',
    date: '09/29/2023',
    marketCap: 1646.3497,
  },
  {
    symbol: 'GOOG',
    date: '10/06/2023',
    marketCap: 1718.099,
  },
  {
    symbol: 'GOOG',
    date: '10/13/2023',
    marketCap: 1715.3517,
  },
  {
    symbol: 'GOOG',
    date: '10/20/2023',
    marketCap: 1693.3728,
  },
  {
    symbol: 'GOOG',
    date: '10/27/2023',
    marketCap: 1525.659,
  },
  {
    symbol: 'GOOG',
    date: '11/03/2023',
    marketCap: 1612.2008,
  },
  {
    symbol: 'GOOG',
    date: '11/10/2023',
    marketCap: 1655.7839,
  },
  {
    symbol: 'GOOG',
    date: '11/17/2023',
    marketCap: 1689.7513,
  },
  {
    symbol: 'GOOG',
    date: '11/24/2023',
    marketCap: 1706.9847,
  },
  {
    symbol: 'GOOG',
    date: '12/01/2023',
    marketCap: 1646.6677,
  },
  {
    symbol: 'GOOG',
    date: '12/08/2023',
    marketCap: 1685.7551,
  },
  {
    symbol: 'GOOG',
    date: '12/15/2023',
    marketCap: 1655.9088,
  },
  {
    symbol: 'GOOG',
    date: '12/22/2023',
    marketCap: 1766.9271,
  },
  {
    symbol: 'GOOG',
    date: '12/29/2023',
    marketCap: 1744.4487,
  },
  {
    symbol: 'GOOG',
    date: '01/05/2024',
    marketCap: 1685.0879,
  },
  {
    symbol: 'GOOG',
    date: '01/12/2024',
    marketCap: 1770.9997,
  },
  {
    symbol: 'GOOG',
    date: '01/19/2024',
    marketCap: 1817.3077,
  },
  {
    symbol: 'GOOG',
    date: '01/26/2024',
    marketCap: 1889.4389,
  },
  {
    symbol: 'GOOG',
    date: '02/02/2024',
    marketCap: 1767.6477,
  },
  {
    symbol: 'GOOG',
    date: '02/09/2024',
    marketCap: 1849.835,
  },
  {
    symbol: 'GOOG',
    date: '02/16/2024',
    marketCap: 1744.5558,
  },
  {
    symbol: 'GOOG',
    date: '02/23/2024',
    marketCap: 1787.2634,
  },
  {
    symbol: 'GOOG',
    date: '03/01/2024',
    marketCap: 1702.5931,
  },
  {
    symbol: 'GOOG',
    date: '03/08/2024',
    marketCap: 1681.1152,
  },
  {
    symbol: 'GOOG',
    date: '03/15/2024',
    marketCap: 1752.7497,
  },
  {
    symbol: 'GOOG',
    date: '03/22/2024',
    marketCap: 1871.8095,
  },
  {
    symbol: 'GOOG',
    date: '03/28/2024',
    marketCap: 1873.7959,
  },
  {
    symbol: 'GOOG',
    date: '04/05/2024',
    marketCap: 1882.3075,
  },
  {
    symbol: 'GOOG',
    date: '04/12/2024',
    marketCap: 1946.8614,
  },
  {
    symbol: 'GOOG',
    date: '04/19/2024',
    marketCap: 1901.9329,
  },
  {
    symbol: 'GOOG',
    date: '04/26/2024',
    marketCap: 2122.3788,
  },
  {
    symbol: 'GOOG',
    date: '05/03/2024',
    marketCap: 2064.2433,
  },
  {
    symbol: 'GOOG',
    date: '05/10/2024',
    marketCap: 2081.6469,
  },
  {
    symbol: 'GOOG',
    date: '05/17/2024',
    marketCap: 2173.1086,
  },
  {
    symbol: 'GOOG',
    date: '05/24/2024',
    marketCap: 2159.9016,
  },
  {
    symbol: 'GOOG',
    date: '05/31/2024',
    marketCap: 2129.1675,
  },
  {
    symbol: 'GOOG',
    date: '06/07/2024',
    marketCap: 2153.3598,
  },
  {
    symbol: 'GOOG',
    date: '06/14/2024',
    marketCap: 2182.119,
  },
  {
    symbol: 'GOOG',
    date: '06/21/2024',
    marketCap: 2217.1731,
  },
  {
    symbol: 'GOOG',
    date: '06/28/2024',
    marketCap: 2248.2775,
  },
  {
    symbol: 'GOOG',
    date: '07/05/2024',
    marketCap: 2352.5758,
  },
  {
    symbol: 'GOOG',
    date: '07/12/2024',
    marketCap: 2284.319,
  },
  {
    symbol: 'GOOG',
    date: '07/19/2024',
    marketCap: 2192.8574,
  },
  {
    symbol: 'GOOG',
    date: '07/26/2024',
    marketCap: 2061.281,
  },
  {
    symbol: 'GOOG',
    date: '08/02/2024',
    marketCap: 2057.0844,
  },
  {
    symbol: 'GOOG',
    date: '08/09/2024',
    marketCap: 2020.1788,
  },
  {
    symbol: 'GOOG',
    date: '08/16/2024',
    marketCap: 2011.4153,
  },
  {
    symbol: 'GOOG',
    date: '08/23/2024',
    marketCap: 2044.2477,
  },
  {
    symbol: 'GOOG',
    date: '08/30/2024',
    marketCap: 2016.5993,
  },
  {
    symbol: 'GOOG',
    date: '09/06/2024',
    marketCap: 1862.8056,
  },
  {
    symbol: 'GOOG',
    date: '09/13/2024',
    marketCap: 1943.5288,
  },
  {
    symbol: 'GOOG',
    date: '09/20/2024',
    marketCap: 2019.1914,
  },
  {
    symbol: 'GOOG',
    date: '09/27/2024',
    marketCap: 2023.6348,
  },
  {
    symbol: 'GOOG',
    date: '10/04/2024',
    marketCap: 2062.0216,
  },
  {
    symbol: 'GOOG',
    date: '10/11/2024',
    marketCap: 2014.8713,
  },
  {
    symbol: 'GOOG',
    date: '10/18/2024',
    marketCap: 2017.0931,
  },
  {
    symbol: 'GOOG',
    date: '10/25/2024',
    marketCap: 2039.9276,
  },
  {
    symbol: 'GOOG',
    date: '11/01/2024',
    marketCap: 2105.1541,
  },
  {
    symbol: 'GOOG',
    date: '11/08/2024',
    marketCap: 2191.9215,
  },
  {
    symbol: 'GOOG',
    date: '11/15/2024',
    marketCap: 2119.9021,
  },
  {
    symbol: 'MSFT',
    date: '09/16/2021',
    marketCap: 2293.1179,
  },
  {
    symbol: 'MSFT',
    date: '09/23/2021',
    marketCap: 2250.5943,
  },
  {
    symbol: 'MSFT',
    date: '09/30/2021',
    marketCap: 2115.8096,
  },
  {
    symbol: 'MSFT',
    date: '10/07/2021',
    marketCap: 2212.8493,
  },
  {
    symbol: 'MSFT',
    date: '10/14/2021',
    marketCap: 2272.1388,
  },
  {
    symbol: 'MSFT',
    date: '10/21/2021',
    marketCap: 2332.2538,
  },
  {
    symbol: 'MSFT',
    date: '10/28/2021',
    marketCap: 2434.2467,
  },
  {
    symbol: 'MSFT',
    date: '11/04/2021',
    marketCap: 2524.9822,
  },
  {
    symbol: 'MSFT',
    date: '11/11/2021',
    marketCap: 2494.8872,
  },
  {
    symbol: 'MSFT',
    date: '11/18/2021',
    marketCap: 2561.2314,
  },
  {
    symbol: 'MSFT',
    date: '11/24/2021',
    marketCap: 2536.0145,
  },
  {
    symbol: 'MSFT',
    date: '12/02/2021',
    marketCap: 2472.8225,
  },
  {
    symbol: 'MSFT',
    date: '12/09/2021',
    marketCap: 2499.9155,
  },
  {
    symbol: 'MSFT',
    date: '12/16/2021',
    marketCap: 2438.3745,
  },
  {
    symbol: 'MSFT',
    date: '12/23/2021',
    marketCap: 2511.8484,
  },
  {
    symbol: 'MSFT',
    date: '12/30/2021',
    marketCap: 2546.5966,
  },
  {
    symbol: 'MSFT',
    date: '12/31/2021',
    marketCap: 2520.0458,
  },
  {
    symbol: 'MSFT',
    date: '01/07/2022',
    marketCap: 2353.1017,
  },
  {
    symbol: 'MSFT',
    date: '01/14/2022',
    marketCap: 2324.3286,
  },
  {
    symbol: 'MSFT',
    date: '01/21/2022',
    marketCap: 2218.1528,
  },
  {
    symbol: 'MSFT',
    date: '01/28/2022',
    marketCap: 2309.7922,
  },
  {
    symbol: 'MSFT',
    date: '02/04/2022',
    marketCap: 2292.4084,
  },
  {
    symbol: 'MSFT',
    date: '02/11/2022',
    marketCap: 2210.7347,
  },
  {
    symbol: 'MSFT',
    date: '02/18/2022',
    marketCap: 2157.4595,
  },
  {
    symbol: 'MSFT',
    date: '02/25/2022',
    marketCap: 2227.7438,
  },
  {
    symbol: 'MSFT',
    date: '03/04/2022',
    marketCap: 2171.921,
  },
  {
    symbol: 'MSFT',
    date: '03/11/2022',
    marketCap: 2098.5645,
  },
  {
    symbol: 'MSFT',
    date: '03/18/2022',
    marketCap: 2251.122,
  },
  {
    symbol: 'MSFT',
    date: '03/25/2022',
    marketCap: 2275.4742,
  },
  {
    symbol: 'MSFT',
    date: '04/01/2022',
    marketCap: 2312.6051,
  },
  {
    symbol: 'MSFT',
    date: '04/08/2022',
    marketCap: 2219.5538,
  },
  {
    symbol: 'MSFT',
    date: '04/14/2022',
    marketCap: 2091.4494,
  },
  {
    symbol: 'MSFT',
    date: '04/22/2022',
    marketCap: 2048.1002,
  },
  {
    symbol: 'MSFT',
    date: '04/29/2022',
    marketCap: 2074.1845,
  },
  {
    symbol: 'MSFT',
    date: '05/06/2022',
    marketCap: 2053.332,
  },
  {
    symbol: 'MSFT',
    date: '05/13/2022',
    marketCap: 1951.6109,
  },
  {
    symbol: 'MSFT',
    date: '05/20/2022',
    marketCap: 1887.6334,
  },
  {
    symbol: 'MSFT',
    date: '05/27/2022',
    marketCap: 2042.1958,
  },
  {
    symbol: 'MSFT',
    date: '06/03/2022',
    marketCap: 2018.1295,
  },
  {
    symbol: 'MSFT',
    date: '06/10/2022',
    marketCap: 1890.8473,
  },
  {
    symbol: 'MSFT',
    date: '06/17/2022',
    marketCap: 1850.9361,
  },
  {
    symbol: 'MSFT',
    date: '06/24/2022',
    marketCap: 2000.7898,
  },
  {
    symbol: 'MSFT',
    date: '07/01/2022',
    marketCap: 1935.6881,
  },
  {
    symbol: 'MSFT',
    date: '07/08/2022',
    marketCap: 1995.9406,
  },
  {
    symbol: 'MSFT',
    date: '07/15/2022',
    marketCap: 1914.361,
  },
  {
    symbol: 'MSFT',
    date: '07/22/2022',
    marketCap: 1941.5045,
  },
  {
    symbol: 'MSFT',
    date: '07/29/2022',
    marketCap: 2093.4782,
  },
  {
    symbol: 'MSFT',
    date: '08/05/2022',
    marketCap: 2109.6599,
  },
  {
    symbol: 'MSFT',
    date: '08/12/2022',
    marketCap: 2176.7729,
  },
  {
    symbol: 'MSFT',
    date: '08/19/2022',
    marketCap: 2133.8205,
  },
  {
    symbol: 'MSFT',
    date: '08/26/2022',
    marketCap: 1999.1471,
  },
  {
    symbol: 'MSFT',
    date: '09/02/2022',
    marketCap: 1909.4394,
  },
  {
    symbol: 'MSFT',
    date: '09/09/2022',
    marketCap: 1972.0782,
  },
  {
    symbol: 'MSFT',
    date: '09/16/2022',
    marketCap: 1825.0262,
  },
  {
    symbol: 'MSFT',
    date: '09/23/2022',
    marketCap: 1774.1694,
  },
  {
    symbol: 'MSFT',
    date: '09/30/2022',
    marketCap: 1735.3379,
  },
  {
    symbol: 'MSFT',
    date: '10/07/2022',
    marketCap: 1745.3222,
  },
  {
    symbol: 'MSFT',
    date: '10/14/2022',
    marketCap: 1703.0006,
  },
  {
    symbol: 'MSFT',
    date: '10/21/2022',
    marketCap: 1804.0361,
  },
  {
    symbol: 'MSFT',
    date: '10/28/2022',
    marketCap: 1757.4674,
  },
  {
    symbol: 'MSFT',
    date: '11/04/2022',
    marketCap: 1649.5769,
  },
  {
    symbol: 'MSFT',
    date: '11/11/2022',
    marketCap: 1841.2166,
  },
  {
    symbol: 'MSFT',
    date: '11/18/2022',
    marketCap: 1797.3302,
  },
  {
    symbol: 'MSFT',
    date: '11/25/2022',
    marketCap: 1844.048,
  },
  {
    symbol: 'MSFT',
    date: '12/02/2022',
    marketCap: 1900.154,
  },
  {
    symbol: 'MSFT',
    date: '12/09/2022',
    marketCap: 1828.6244,
  },
  {
    symbol: 'MSFT',
    date: '12/16/2022',
    marketCap: 1823.1852,
  },
  {
    symbol: 'MSFT',
    date: '12/23/2022',
    marketCap: 1778.7772,
  },
  {
    symbol: 'MSFT',
    date: '12/30/2022',
    marketCap: 1786.8988,
  },
  {
    symbol: 'MSFT',
    date: '01/06/2023',
    marketCap: 1673.7041,
  },
  {
    symbol: 'MSFT',
    date: '01/13/2023',
    marketCap: 1780.1104,
  },
  {
    symbol: 'MSFT',
    date: '01/20/2023',
    marketCap: 1787.477,
  },
  {
    symbol: 'MSFT',
    date: '01/27/2023',
    marketCap: 1846.5586,
  },
  {
    symbol: 'MSFT',
    date: '02/03/2023',
    marketCap: 1922.3824,
  },
  {
    symbol: 'MSFT',
    date: '02/10/2023',
    marketCap: 1957.7271,
  },
  {
    symbol: 'MSFT',
    date: '02/17/2023',
    marketCap: 1920.2245,
  },
  {
    symbol: 'MSFT',
    date: '02/24/2023',
    marketCap: 1854.446,
  },
  {
    symbol: 'MSFT',
    date: '03/03/2023',
    marketCap: 1899.6129,
  },
  {
    symbol: 'MSFT',
    date: '03/10/2023',
    marketCap: 1849.7582,
  },
  {
    symbol: 'MSFT',
    date: '03/17/2023',
    marketCap: 2079.2386,
  },
  {
    symbol: 'MSFT',
    date: '03/24/2023',
    marketCap: 2087.7214,
  },
  {
    symbol: 'MSFT',
    date: '03/31/2023',
    marketCap: 2143.2222,
  },
  {
    symbol: 'MSFT',
    date: '04/06/2023',
    marketCap: 2167.7544,
  },
  {
    symbol: 'MSFT',
    date: '04/14/2023',
    marketCap: 2127.1648,
  },
  {
    symbol: 'MSFT',
    date: '04/21/2023',
    marketCap: 2124.3398,
  },
  {
    symbol: 'MSFT',
    date: '04/28/2023',
    marketCap: 2284.1708,
  },
  {
    symbol: 'MSFT',
    date: '05/05/2023',
    marketCap: 2309.3721,
  },
  {
    symbol: 'MSFT',
    date: '05/12/2023',
    marketCap: 2296.883,
  },
  {
    symbol: 'MSFT',
    date: '05/19/2023',
    marketCap: 2366.5396,
  },
  {
    symbol: 'MSFT',
    date: '05/26/2023',
    marketCap: 2474.7043,
  },
  {
    symbol: 'MSFT',
    date: '06/02/2023',
    marketCap: 2493.3636,
  },
  {
    symbol: 'MSFT',
    date: '06/09/2023',
    marketCap: 2429.3569,
  },
  {
    symbol: 'MSFT',
    date: '06/16/2023',
    marketCap: 2544.8812,
  },
  {
    symbol: 'MSFT',
    date: '06/23/2023',
    marketCap: 2490.5387,
  },
  {
    symbol: 'MSFT',
    date: '06/30/2023',
    marketCap: 2529.8717,
  },
  {
    symbol: 'MSFT',
    date: '07/07/2023',
    marketCap: 2505.2074,
  },
  {
    symbol: 'MSFT',
    date: '07/14/2023',
    marketCap: 2564.788,
  },
  {
    symbol: 'MSFT',
    date: '07/21/2023',
    marketCap: 2553.8673,
  },
  {
    symbol: 'MSFT',
    date: '07/28/2023',
    marketCap: 2513.7507,
  },
  {
    symbol: 'MSFT',
    date: '08/04/2023',
    marketCap: 2435.0776,
  },
  {
    symbol: 'MSFT',
    date: '08/11/2023',
    marketCap: 2384.7833,
  },
  {
    symbol: 'MSFT',
    date: '08/18/2023',
    marketCap: 2351.1299,
  },
  {
    symbol: 'MSFT',
    date: '08/25/2023',
    marketCap: 2399.4184,
  },
  {
    symbol: 'MSFT',
    date: '09/01/2023',
    marketCap: 2441.6151,
  },
  {
    symbol: 'MSFT',
    date: '09/08/2023',
    marketCap: 2483.2918,
  },
  {
    symbol: 'MSFT',
    date: '09/15/2023',
    marketCap: 2453.2044,
  },
  {
    symbol: 'MSFT',
    date: '09/22/2023',
    marketCap: 2355.0673,
  },
  {
    symbol: 'MSFT',
    date: '09/29/2023',
    marketCap: 2345.7067,
  },
  {
    symbol: 'MSFT',
    date: '10/06/2023',
    marketCap: 2432.1963,
  },
  {
    symbol: 'MSFT',
    date: '10/13/2023',
    marketCap: 2435.6894,
  },
  {
    symbol: 'MSFT',
    date: '10/20/2023',
    marketCap: 2427.8114,
  },
  {
    symbol: 'MSFT',
    date: '10/27/2023',
    marketCap: 2451.1479,
  },
  {
    symbol: 'MSFT',
    date: '11/03/2023',
    marketCap: 2622.0096,
  },
  {
    symbol: 'MSFT',
    date: '11/10/2023',
    marketCap: 2747.3874,
  },
  {
    symbol: 'MSFT',
    date: '11/17/2023',
    marketCap: 2748.7252,
  },
  {
    symbol: 'MSFT',
    date: '11/24/2023',
    marketCap: 2805.0598,
  },
  {
    symbol: 'MSFT',
    date: '12/01/2023',
    marketCap: 2783.3583,
  },
  {
    symbol: 'MSFT',
    date: '12/08/2023',
    marketCap: 2781.2774,
  },
  {
    symbol: 'MSFT',
    date: '12/15/2023',
    marketCap: 2755.2654,
  },
  {
    symbol: 'MSFT',
    date: '12/22/2023',
    marketCap: 2783.8786,
  },
  {
    symbol: 'MSFT',
    date: '12/29/2023',
    marketCap: 2794.7293,
  },
  {
    symbol: 'MSFT',
    date: '01/05/2024',
    marketCap: 2732.7503,
  },
  {
    symbol: 'MSFT',
    date: '01/12/2024',
    marketCap: 2886.7206,
  },
  {
    symbol: 'MSFT',
    date: '01/19/2024',
    marketCap: 2962.5168,
  },
  {
    symbol: 'MSFT',
    date: '01/26/2024',
    marketCap: 3001.6038,
  },
  {
    symbol: 'MSFT',
    date: '02/02/2024',
    marketCap: 3055.7758,
  },
  {
    symbol: 'MSFT',
    date: '02/09/2024',
    marketCap: 3125.1071,
  },
  {
    symbol: 'MSFT',
    date: '02/16/2024',
    marketCap: 3002.5699,
  },
  {
    symbol: 'MSFT',
    date: '02/23/2024',
    marketCap: 3049.2365,
  },
  {
    symbol: 'MSFT',
    date: '03/01/2024',
    marketCap: 3087.5805,
  },
  {
    symbol: 'MSFT',
    date: '03/08/2024',
    marketCap: 3018.6208,
  },
  {
    symbol: 'MSFT',
    date: '03/15/2024',
    marketCap: 3094.417,
  },
  {
    symbol: 'MSFT',
    date: '03/22/2024',
    marketCap: 3185.9669,
  },
  {
    symbol: 'MSFT',
    date: '03/28/2024',
    marketCap: 3126.3703,
  },
  {
    symbol: 'MSFT',
    date: '04/05/2024',
    marketCap: 3162.8902,
  },
  {
    symbol: 'MSFT',
    date: '04/12/2024',
    marketCap: 3135.9827,
  },
  {
    symbol: 'MSFT',
    date: '04/19/2024',
    marketCap: 2966.659,
  },
  {
    symbol: 'MSFT',
    date: '04/26/2024',
    marketCap: 3020.1766,
  },
  {
    symbol: 'MSFT',
    date: '05/03/2024',
    marketCap: 3022.7038,
  },
  {
    symbol: 'MSFT',
    date: '05/10/2024',
    marketCap: 3082.7624,
  },
  {
    symbol: 'MSFT',
    date: '05/17/2024',
    marketCap: 3123.4209,
  },
  {
    symbol: 'MSFT',
    date: '05/24/2024',
    marketCap: 3197.3793,
  },
  {
    symbol: 'MSFT',
    date: '05/31/2024',
    marketCap: 3085.6613,
  },
  {
    symbol: 'MSFT',
    date: '06/07/2024',
    marketCap: 3150.477,
  },
  {
    symbol: 'MSFT',
    date: '06/14/2024',
    marketCap: 3289.6228,
  },
  {
    symbol: 'MSFT',
    date: '06/21/2024',
    marketCap: 3343.2147,
  },
  {
    symbol: 'MSFT',
    date: '06/28/2024',
    marketCap: 3322.1793,
  },
  {
    symbol: 'MSFT',
    date: '07/05/2024',
    marketCap: 3475.3735,
  },
  {
    symbol: 'MSFT',
    date: '07/12/2024',
    marketCap: 3371.2371,
  },
  {
    symbol: 'MSFT',
    date: '07/19/2024',
    marketCap: 3249.0386,
  },
  {
    symbol: 'MSFT',
    date: '07/26/2024',
    marketCap: 3161.0319,
  },
  {
    symbol: 'MSFT',
    date: '08/02/2024',
    marketCap: 3036.3062,
  },
  {
    symbol: 'MSFT',
    date: '08/09/2024',
    marketCap: 3017.9467,
  },
  {
    symbol: 'MSFT',
    date: '08/16/2024',
    marketCap: 3110.4875,
  },
  {
    symbol: 'MSFT',
    date: '08/23/2024',
    marketCap: 3098.0001,
  },
  {
    symbol: 'MSFT',
    date: '08/30/2024',
    marketCap: 3100.6016,
  },
  {
    symbol: 'MSFT',
    date: '09/06/2024',
    marketCap: 2985.8361,
  },
  {
    symbol: 'MSFT',
    date: '09/13/2024',
    marketCap: 3200.5755,
  },
  {
    symbol: 'MSFT',
    date: '09/20/2024',
    marketCap: 3235.3619,
  },
  {
    symbol: 'MSFT',
    date: '09/27/2024',
    marketCap: 3181.4727,
  },
  {
    symbol: 'MSFT',
    date: '10/04/2024',
    marketCap: 3092.574,
  },
  {
    symbol: 'MSFT',
    date: '10/11/2024',
    marketCap: 3094.5066,
  },
  {
    symbol: 'MSFT',
    date: '10/18/2024',
    marketCap: 3108.1833,
  },
  {
    symbol: 'MSFT',
    date: '10/25/2024',
    marketCap: 3182.439,
  },
  {
    symbol: 'MSFT',
    date: '11/01/2024',
    marketCap: 3050.2802,
  },
  {
    symbol: 'MSFT',
    date: '11/08/2024',
    marketCap: 3140.7398,
  },
  {
    symbol: 'MSFT',
    date: '11/15/2024',
    marketCap: 3084.695,
  },
  {
    symbol: 'NVDA',
    date: '09/16/2021',
    marketCap: 555.7776,
  },
  {
    symbol: 'NVDA',
    date: '09/23/2021',
    marketCap: 561.7752,
  },
  {
    symbol: 'NVDA',
    date: '09/30/2021',
    marketCap: 517.7928,
  },
  {
    symbol: 'NVDA',
    date: '10/07/2021',
    marketCap: 526.7892,
  },
  {
    symbol: 'NVDA',
    date: '10/14/2021',
    marketCap: 543.5325,
  },
  {
    symbol: 'NVDA',
    date: '10/21/2021',
    marketCap: 567.0231,
  },
  {
    symbol: 'NVDA',
    date: '10/28/2021',
    marketCap: 623.2506,
  },
  {
    symbol: 'NVDA',
    date: '11/04/2021',
    marketCap: 746.192,
  },
  {
    symbol: 'NVDA',
    date: '11/11/2021',
    marketCap: 760.9656,
  },
  {
    symbol: 'NVDA',
    date: '11/18/2021',
    marketCap: 793.2672,
  },
  {
    symbol: 'NVDA',
    date: '11/24/2021',
    marketCap: 818.0568,
  },
  {
    symbol: 'NVDA',
    date: '12/02/2021',
    marketCap: 804.5352,
  },
  {
    symbol: 'NVDA',
    date: '12/09/2021',
    marketCap: 763.4696,
  },
  {
    symbol: 'NVDA',
    date: '12/16/2021',
    marketCap: 710.8856,
  },
  {
    symbol: 'NVDA',
    date: '12/23/2021',
    marketCap: 742.1856,
  },
  {
    symbol: 'NVDA',
    date: '12/30/2021',
    marketCap: 740.9336,
  },
  {
    symbol: 'NVDA',
    date: '12/31/2021',
    marketCap: 736.4264,
  },
  {
    symbol: 'NVDA',
    date: '01/07/2022',
    marketCap: 682.34,
  },
  {
    symbol: 'NVDA',
    date: '01/14/2022',
    marketCap: 674.5776,
  },
  {
    symbol: 'NVDA',
    date: '01/21/2022',
    marketCap: 585.1848,
  },
  {
    symbol: 'NVDA',
    date: '01/28/2022',
    marketCap: 571.9136,
  },
  {
    symbol: 'NVDA',
    date: '02/04/2022',
    marketCap: 609.4592,
  },
  {
    symbol: 'NVDA',
    date: '02/11/2022',
    marketCap: 600.187,
  },
  {
    symbol: 'NVDA',
    date: '02/18/2022',
    marketCap: 592.4184,
  },
  {
    symbol: 'NVDA',
    date: '02/25/2022',
    marketCap: 605.4496,
  },
  {
    symbol: 'NVDA',
    date: '03/04/2022',
    marketCap: 574.8764,
  },
  {
    symbol: 'NVDA',
    date: '03/11/2022',
    marketCap: 553.826,
  },
  {
    symbol: 'NVDA',
    date: '03/18/2022',
    marketCap: 662.837,
  },
  {
    symbol: 'NVDA',
    date: '03/25/2022',
    marketCap: 693.9114,
  },
  {
    symbol: 'NVDA',
    date: '04/01/2022',
    marketCap: 669.3526,
  },
  {
    symbol: 'NVDA',
    date: '04/08/2022',
    marketCap: 579.3872,
  },
  {
    symbol: 'NVDA',
    date: '04/14/2022',
    marketCap: 532.7756,
  },
  {
    symbol: 'NVDA',
    date: '04/22/2022',
    marketCap: 489.1712,
  },
  {
    symbol: 'NVDA',
    date: '04/29/2022',
    marketCap: 464.863,
  },
  {
    symbol: 'NVDA',
    date: '05/06/2022',
    marketCap: 466.066,
  },
  {
    symbol: 'NVDA',
    date: '05/13/2022',
    marketCap: 441.8645,
  },
  {
    symbol: 'NVDA',
    date: '05/20/2022',
    marketCap: 416.4155,
  },
  {
    symbol: 'NVDA',
    date: '05/27/2022',
    marketCap: 469.3095,
  },
  {
    symbol: 'NVDA',
    date: '06/03/2022',
    marketCap: 467.064,
  },
  {
    symbol: 'NVDA',
    date: '06/10/2022',
    marketCap: 423.4015,
  },
  {
    symbol: 'NVDA',
    date: '06/17/2022',
    marketCap: 396.206,
  },
  {
    symbol: 'NVDA',
    date: '06/24/2022',
    marketCap: 427.3935,
  },
  {
    symbol: 'NVDA',
    date: '07/01/2022',
    marketCap: 362.274,
  },
  {
    symbol: 'NVDA',
    date: '07/08/2022',
    marketCap: 395.208,
  },
  {
    symbol: 'NVDA',
    date: '07/15/2022',
    marketCap: 393.212,
  },
  {
    symbol: 'NVDA',
    date: '07/22/2022',
    marketCap: 432.134,
  },
  {
    symbol: 'NVDA',
    date: '07/29/2022',
    marketCap: 453.092,
  },
  {
    symbol: 'NVDA',
    date: '08/05/2022',
    marketCap: 471.5217,
  },
  {
    symbol: 'NVDA',
    date: '08/12/2022',
    marketCap: 464.5693,
  },
  {
    symbol: 'NVDA',
    date: '08/19/2022',
    marketCap: 443.2155,
  },
  {
    symbol: 'NVDA',
    date: '08/26/2022',
    marketCap: 403.7358,
  },
  {
    symbol: 'NVDA',
    date: '09/02/2022',
    marketCap: 338.9295,
  },
  {
    symbol: 'NVDA',
    date: '09/09/2022',
    marketCap: 357.3037,
  },
  {
    symbol: 'NVDA',
    date: '09/16/2022',
    marketCap: 327.756,
  },
  {
    symbol: 'NVDA',
    date: '09/23/2022',
    marketCap: 310.8716,
  },
  {
    symbol: 'NVDA',
    date: '09/30/2022',
    marketCap: 301.4362,
  },
  {
    symbol: 'NVDA',
    date: '10/07/2022',
    marketCap: 299.9464,
  },
  {
    symbol: 'NVDA',
    date: '10/14/2022',
    marketCap: 278.8409,
  },
  {
    symbol: 'NVDA',
    date: '10/21/2022',
    marketCap: 309.6301,
  },
  {
    symbol: 'NVDA',
    date: '10/28/2022',
    marketCap: 343.3989,
  },
  {
    symbol: 'NVDA',
    date: '11/04/2022',
    marketCap: 348.9024,
  },
  {
    symbol: 'NVDA',
    date: '11/11/2022',
    marketCap: 402.3712,
  },
  {
    symbol: 'NVDA',
    date: '11/18/2022',
    marketCap: 379.7024,
  },
  {
    symbol: 'NVDA',
    date: '11/25/2022',
    marketCap: 400.8928,
  },
  {
    symbol: 'NVDA',
    date: '12/02/2022',
    marketCap: 415.9232,
  },
  {
    symbol: 'NVDA',
    date: '12/09/2022',
    marketCap: 418.88,
  },
  {
    symbol: 'NVDA',
    date: '12/16/2022',
    marketCap: 408.2848,
  },
  {
    symbol: 'NVDA',
    date: '12/23/2022',
    marketCap: 374.7744,
  },
  {
    symbol: 'NVDA',
    date: '12/30/2022',
    marketCap: 359.9904,
  },
  {
    symbol: 'NVDA',
    date: '01/06/2023',
    marketCap: 366.1504,
  },
  {
    symbol: 'NVDA',
    date: '01/13/2023',
    marketCap: 416.416,
  },
  {
    symbol: 'NVDA',
    date: '01/20/2023',
    marketCap: 439.5776,
  },
  {
    symbol: 'NVDA',
    date: '01/27/2023',
    marketCap: 501.6704,
  },
  {
    symbol: 'NVDA',
    date: '02/03/2023',
    marketCap: 521.17,
  },
  {
    symbol: 'NVDA',
    date: '02/10/2023',
    marketCap: 525.369,
  },
  {
    symbol: 'NVDA',
    date: '02/17/2023',
    marketCap: 528.333,
  },
  {
    symbol: 'NVDA',
    date: '02/24/2023',
    marketCap: 575.263,
  },
  {
    symbol: 'NVDA',
    date: '03/03/2023',
    marketCap: 590.083,
  },
  {
    symbol: 'NVDA',
    date: '03/10/2023',
    marketCap: 567.359,
  },
  {
    symbol: 'NVDA',
    date: '03/17/2023',
    marketCap: 635.531,
  },
  {
    symbol: 'NVDA',
    date: '03/24/2023',
    marketCap: 661.466,
  },
  {
    symbol: 'NVDA',
    date: '03/31/2023',
    marketCap: 686.166,
  },
  {
    symbol: 'NVDA',
    date: '04/06/2023',
    marketCap: 667.888,
  },
  {
    symbol: 'NVDA',
    date: '04/14/2023',
    marketCap: 660.972,
  },
  {
    symbol: 'NVDA',
    date: '04/21/2023',
    marketCap: 669.864,
  },
  {
    symbol: 'NVDA',
    date: '04/28/2023',
    marketCap: 685.425,
  },
  {
    symbol: 'NVDA',
    date: '05/05/2023',
    marketCap: 709.2564,
  },
  {
    symbol: 'NVDA',
    date: '05/12/2023',
    marketCap: 700.8482,
  },
  {
    symbol: 'NVDA',
    date: '05/19/2023',
    marketCap: 773.0598,
  },
  {
    symbol: 'NVDA',
    date: '05/26/2023',
    marketCap: 963.2335,
  },
  {
    symbol: 'NVDA',
    date: '06/02/2023',
    marketCap: 972.6309,
  },
  {
    symbol: 'NVDA',
    date: '06/09/2023',
    marketCap: 958.7821,
  },
  {
    symbol: 'NVDA',
    date: '06/16/2023',
    marketCap: 1055.7237,
  },
  {
    symbol: 'NVDA',
    date: '06/23/2023',
    marketCap: 1043.8533,
  },
  {
    symbol: 'NVDA',
    date: '06/30/2023',
    marketCap: 1046.079,
  },
  {
    symbol: 'NVDA',
    date: '07/07/2023',
    marketCap: 1051.025,
  },
  {
    symbol: 'NVDA',
    date: '07/14/2023',
    marketCap: 1124.4731,
  },
  {
    symbol: 'NVDA',
    date: '07/21/2023',
    marketCap: 1095.7863,
  },
  {
    symbol: 'NVDA',
    date: '07/28/2023',
    marketCap: 1156.1275,
  },
  {
    symbol: 'NVDA',
    date: '08/04/2023',
    marketCap: 1102.7024,
  },
  {
    symbol: 'NVDA',
    date: '08/11/2023',
    marketCap: 1008.178,
  },
  {
    symbol: 'NVDA',
    date: '08/18/2023',
    marketCap: 1068.644,
  },
  {
    symbol: 'NVDA',
    date: '08/25/2023',
    marketCap: 1135.7736,
  },
  {
    symbol: 'NVDA',
    date: '09/01/2023',
    marketCap: 1197.2268,
  },
  {
    symbol: 'NVDA',
    date: '09/08/2023',
    marketCap: 1124.6676,
  },
  {
    symbol: 'NVDA',
    date: '09/15/2023',
    marketCap: 1083.452,
  },
  {
    symbol: 'NVDA',
    date: '09/22/2023',
    marketCap: 1026.9348,
  },
  {
    symbol: 'NVDA',
    date: '09/29/2023',
    marketCap: 1073.58,
  },
  {
    symbol: 'NVDA',
    date: '10/06/2023',
    marketCap: 1129.3568,
  },
  {
    symbol: 'NVDA',
    date: '10/13/2023',
    marketCap: 1121.9528,
  },
  {
    symbol: 'NVDA',
    date: '10/20/2023',
    marketCap: 1021.5052,
  },
  {
    symbol: 'NVDA',
    date: '10/27/2023',
    marketCap: 999.54,
  },
  {
    symbol: 'NVDA',
    date: '11/03/2023',
    marketCap: 1109.9466,
  },
  {
    symbol: 'NVDA',
    date: '11/10/2023',
    marketCap: 1192.0644,
  },
  {
    symbol: 'NVDA',
    date: '11/17/2023',
    marketCap: 1215.738,
  },
  {
    symbol: 'NVDA',
    date: '11/24/2023',
    marketCap: 1178.2548,
  },
  {
    symbol: 'NVDA',
    date: '12/01/2023',
    marketCap: 1153.3482,
  },
  {
    symbol: 'NVDA',
    date: '12/08/2023',
    marketCap: 1171.5966,
  },
  {
    symbol: 'NVDA',
    date: '12/15/2023',
    marketCap: 1205.6274,
  },
  {
    symbol: 'NVDA',
    date: '12/22/2023',
    marketCap: 1204.1478,
  },
  {
    symbol: 'NVDA',
    date: '12/29/2023',
    marketCap: 1221.1632,
  },
  {
    symbol: 'NVDA',
    date: '01/05/2024',
    marketCap: 1210.806,
  },
  {
    symbol: 'NVDA',
    date: '01/12/2024',
    marketCap: 1349.1486,
  },
  {
    symbol: 'NVDA',
    date: '01/19/2024',
    marketCap: 1467.0234,
  },
  {
    symbol: 'NVDA',
    date: '01/26/2024',
    marketCap: 1504.9998,
  },
  {
    symbol: 'NVDA',
    date: '02/02/2024',
    marketCap: 1628.8592,
  },
  {
    symbol: 'NVDA',
    date: '02/09/2024',
    marketCap: 1775.8406,
  },
  {
    symbol: 'NVDA',
    date: '02/16/2024',
    marketCap: 1787.6582,
  },
  {
    symbol: 'NVDA',
    date: '02/23/2024',
    marketCap: 1940.5484,
  },
  {
    symbol: 'NVDA',
    date: '03/01/2024',
    marketCap: 2025.7336,
  },
  {
    symbol: 'NVDA',
    date: '03/08/2024',
    marketCap: 2154.9886,
  },
  {
    symbol: 'NVDA',
    date: '03/15/2024',
    marketCap: 2162.6208,
  },
  {
    symbol: 'NVDA',
    date: '03/22/2024',
    marketCap: 2321.4198,
  },
  {
    symbol: 'NVDA',
    date: '03/28/2024',
    marketCap: 2224.6632,
  },
  {
    symbol: 'NVDA',
    date: '04/05/2024',
    marketCap: 2166.8062,
  },
  {
    symbol: 'NVDA',
    date: '04/12/2024',
    marketCap: 2171.2378,
  },
  {
    symbol: 'NVDA',
    date: '04/19/2024',
    marketCap: 1876.044,
  },
  {
    symbol: 'NVDA',
    date: '04/26/2024',
    marketCap: 2160.1588,
  },
  {
    symbol: 'NVDA',
    date: '05/03/2024',
    marketCap: 2182.2806,
  },
  {
    symbol: 'NVDA',
    date: '05/10/2024',
    marketCap: 2209.0706,
  },
  {
    symbol: 'NVDA',
    date: '05/17/2024',
    marketCap: 2272.9734,
  },
  {
    symbol: 'NVDA',
    date: '05/24/2024',
    marketCap: 2616.8197,
  },
  {
    symbol: 'NVDA',
    date: '05/31/2024',
    marketCap: 2694.4861,
  },
  {
    symbol: 'NVDA',
    date: '06/07/2024',
    marketCap: 2971.2344,
  },
  {
    symbol: 'NVDA',
    date: '06/14/2024',
    marketCap: 3241.3466,
  },
  {
    symbol: 'NVDA',
    date: '06/21/2024',
    marketCap: 3110.8375,
  },
  {
    symbol: 'NVDA',
    date: '06/28/2024',
    marketCap: 3036.3661,
  },
  {
    symbol: 'NVDA',
    date: '07/05/2024',
    marketCap: 3092.6497,
  },
  {
    symbol: 'NVDA',
    date: '07/12/2024',
    marketCap: 3176.4607,
  },
  {
    symbol: 'NVDA',
    date: '07/19/2024',
    marketCap: 2898.4835,
  },
  {
    symbol: 'NVDA',
    date: '07/26/2024',
    marketCap: 2778.7887,
  },
  {
    symbol: 'NVDA',
    date: '08/02/2024',
    marketCap: 2636.4821,
  },
  {
    symbol: 'NVDA',
    date: '08/09/2024',
    marketCap: 2574.5455,
  },
  {
    symbol: 'NVDA',
    date: '08/16/2024',
    marketCap: 3061.9272,
  },
  {
    symbol: 'NVDA',
    date: '08/23/2024',
    marketCap: 3179.6559,
  },
  {
    symbol: 'NVDA',
    date: '08/30/2024',
    marketCap: 2933.8759,
  },
  {
    symbol: 'NVDA',
    date: '09/06/2024',
    marketCap: 2527.3557,
  },
  {
    symbol: 'NVDA',
    date: '09/13/2024',
    marketCap: 2927.2398,
  },
  {
    symbol: 'NVDA',
    date: '09/20/2024',
    marketCap: 2851.048,
  },
  {
    symbol: 'NVDA',
    date: '09/27/2024',
    marketCap: 2983.7692,
  },
  {
    symbol: 'NVDA',
    date: '10/04/2024',
    marketCap: 3070.2838,
  },
  {
    symbol: 'NVDA',
    date: '10/11/2024',
    marketCap: 3313.1144,
  },
  {
    symbol: 'NVDA',
    date: '10/18/2024',
    marketCap: 3391.764,
  },
  {
    symbol: 'NVDA',
    date: '10/25/2024',
    marketCap: 3478.7701,
  },
  {
    symbol: 'NVDA',
    date: '11/01/2024',
    marketCap: 3327.8612,
  },
  {
    symbol: 'NVDA',
    date: '11/08/2024',
    marketCap: 3628.4501,
  },
  {
    symbol: 'NVDA',
    date: '11/15/2024',
    marketCap: 3489.5844,
  },
]
